export default __webpack_public_path__ + "static/media/WD-1506 metal all in one touch pos system.91f098c2.jpg";